import Back from '@/assets/icons/back.svg?react';
import SettingsDrawer from '../SettingsDrawer';
import { Link } from 'wouter';
import { Button } from '../ui/button';

export default function Header() {
  return (
    <header className="flex flex-col pt-2 pb-6">
      <div className="-mr-[2px] -ml-2 flex items-center justify-between pb-6">
        <Link to="/">
          <Button variant="ghost" size="icon">
            <Back />
          </Button>
        </Link>
        <SettingsDrawer />
      </div>
      <h1 className="text-left text-3xl font-semibold">Receipts</h1>
    </header>
  );
}
